import type { Currency } from '@shared/utils';
import type { LotteryName, Participation } from '../../types';
import { calculateDefaultWinnings, getCalculator } from './calculators';

/**
 * Calculates the total winnings for all lines in a participation.
 * If participation.realWinning is present, it is assumed to be the final
 * amount in the ticket's currency and is returned as-is. Otherwise the
 * function uses lottery-specific calculators when available, falling
 * back to the default line-based calculation.
 *
 * @param lotteryName - The name of the lottery
 * @param participation - The participation data containing lineWinningInfo
 * @param options - Optional array of options (e.g., 'powerPlay' for Powerball)
 * @param currency - The currency to calculate winnings in
 * @returns The total winnings amount
 */
function getLinesWinnings(lotteryName: LotteryName, participation: Participation, options: string[], currency: Currency) {
  if (participation.realWinning != null) {
    return participation.realWinning;
  }

  const calculator = getCalculator(lotteryName);

  if (calculator) {
    return calculator({ participation, options, currency });
  }

  return calculateDefaultWinnings(participation.lineWinningInfo, currency);
}

export { getLinesWinnings };
